// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".border[data-v-1bf8a822]{border:.052083rem solid #000;width:100%;padding:1.041667rem}.Application[data-v-1bf8a822]{justify-content:right;margin-bottom:.260417rem}.flex[data-v-1bf8a822]{display:flex;align-items:center}.icons[data-v-1bf8a822]{cursor:pointer}.inputOn[data-v-1bf8a822]{justify-content:center}", ""]);
// Exports
module.exports = exports;
